// Đọc file phía client để test upload offline (chưa cần backend).
// - Text: cho HTML.
// - DataURL (base64): cho ảnh/PDF nhỏ — lưu thẳng vào thẻ, hiển thị ngay.
// (Phase B2 sẽ thay bằng upload lên /teacher/assets cho file lớn / production.)
export function readFileAsText(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const r = new FileReader()
    r.onload = () => resolve(String(r.result || ''))
    r.onerror = () => reject(r.error || new Error('Không đọc được file'))
    r.readAsText(file)
  })
}

export function readFileAsDataURL(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const r = new FileReader()
    r.onload = () => resolve(String(r.result || ''))
    r.onerror = () => reject(r.error || new Error('Không đọc được file'))
    r.readAsDataURL(file)
  })
}
